module.exports = __webpack_public_path__ + "img/00_bg_03.91d429bf.png";